export default {
  ADD(state,num){
    state.count += num
  }
}